/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getTransactionCodesList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION_CODES,
    'api/v1/rpt/administrator/settings/transaction_codes?isPaginate=1',
    payload,
    callback
  );

export const getSingleTransactCode = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_TRANSACT_CODE,
    `api/v1/rpt/administrator/settings/transaction_codes/${id}`,
    payload,
    callback
  );

export const createTransactionCode = (payload, callback) =>
  req.create(
    c.CREATE_TRANSACTION_CODE,
    'api/v1/rpt/administrator/settings/transaction_codes',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateTransactionCode = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION_CODE,
    `api/v1/rpt/administrator/settings/transaction_codes/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeTransactionCode = (id, payload, callback) =>
  req.remove(
    c.REMOVE_TRANSACTION_CODE,
    `api/v1/rpt/administrator/settings/transaction_codes/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );
